import React, { useCallback, useEffect, useState } from "react";
import { MockSetApplication, getJobAdministratorSettings } from "./setting-applicaation.type";
import SettingList from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier";
import { useSettingsDraft } from "../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context";

const PAGE_KEY = "application";

const ApplicationSet = () => {
  const { getToggle, setToggle, getInput, setInput, hydrateMany } = useSettingsDraft();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        const res = await getJobAdministratorSettings();
        if (!alive) return;

        const s = res.data.data.settings;

        const rawFormat = s.code?.format;

        let uiFormat = "";
        try {
          uiFormat = rawFormat ? JSON.parse(rawFormat)?.format ?? "" : "";
        } catch {
          uiFormat = "";
        }

        hydrateMany({
          pageKey: PAGE_KEY,
          toggles: [
            { groupId: 1, itemId: 1, value: !!s.post.requireApproval },
            { groupId: 1, itemId: 2, value: !!s.post.autoUnpublishOnExpiry },
          ],
          inputs: [
            { groupId: 1, itemId: 3, value: String(s.post.defaultExpiryDays ?? "") },
            { groupId: 1, itemId: 4, value: uiFormat }, // <-- show clean format string in UI
          ],
        });
      } catch (e) {
        console.error("GET job-administrator settings failed:", e);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, [hydrateMany]);

  const isChecked = useCallback(
    (groupId: number, itemId: number) => getToggle(PAGE_KEY, groupId, itemId),
    [getToggle]
  );

  const onToggle = useCallback(
    (payload: {
      groupId: number;
      groupTitle: string;
      itemId: number;
      itemTitle: string;
      checked: boolean;
    }) => {
      setToggle({
        pageKey: PAGE_KEY,
        groupId: payload.groupId,
        groupTitle: payload.groupTitle,
        itemId: payload.itemId,
        itemTitle: payload.itemTitle,
        value: payload.checked,
      });
    },
    [setToggle]
  );

  const getInputValue = useCallback(
    (groupId: number, itemId: number) => getInput(PAGE_KEY, groupId, itemId),
    [getInput]
  );

  const onInputChange = useCallback(
    (groupId: number, itemId: number, value: string, groupTitle?: string, itemTitle?: string) => {
      setInput({
        pageKey: PAGE_KEY,
        groupId,
        groupTitle,
        itemId,
        itemTitle,
        value,
      });
    },
    [setInput]
  );

  return (
    <main>
      {MockSetApplication.map((group) => (
        <SettingList
          key={group.id}
          groupId={group.id}
          mainTitle={group.title}
          paragraph={group.description}
          setList={group.items}
          isChecked={isChecked}
          onToggle={onToggle}
          getInputValue={getInputValue}
          onInputChange={(groupId, itemId, value) => {
            const item = group.items.find((x) => x.id === itemId);
            onInputChange(groupId, itemId, value, group.title, item?.title);
          }}
        />
      ))
      }
    </main>
  );
};

export default ApplicationSet;